import dayjs from 'dayjs';
import * as React from 'react';
import { useIntl } from 'react-intl';
import TooltipComponent from '../../TooltipComponent';
import { END_TYPE, MIDNIGHT_ID, PARKING_TYPE, START_TYPE } from '../constants';
import { getDay } from '../TripsOverviewService';

interface IEventTitleProps {
  index: number;
  title: string;
  duration: string | null;
  activatedAt: string | null;
  type: string;
  isLast: boolean;
  rideId: string;
  isAnonym: boolean;
}

function EventTitle(props: IEventTitleProps): JSX.Element {
  const { formatMessage: f } = useIntl();
  const [isLong, setIsLong] = React.useState<boolean | null>(null);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => {
    if (props.title) {
      const text = document.getElementById(`event-title-${props.rideId}-${props.index}`);
      if (text && !isLong && text.clientHeight > 19) {
        setIsLong(true);
      }
    }
  });

  const getDuration = (): JSX.Element | null => {
    return props.duration && props.type !== START_TYPE && props.type !== END_TYPE ? (
      <span> ({props.duration})</span>
    ) : null;
  };

  const getIcon = (type: string) => {
    if (type === START_TYPE) {
      return 'key';
    }
    if (type === END_TYPE) {
      return 'parking';
    }
    // if (type === PARKING_TYPE) {
    //   return 'ride-stops';
    // }
    if (type === MIDNIGHT_ID) {
      return 'midnight';
    }
    if (type === PARKING_TYPE) {
      return 'pause';
    }
    return type;
  };

  const getTextColor = (type: string) => {
    if (
      type === START_TYPE ||
      type === END_TYPE
      // || type === PARKING_TYPE
    ) {
      return 'text-gray-light';
    }
    return '';
  };

  const getGdprIcon = (): JSX.Element => {
    return (
      <>
        <i className="cmd-icons cmd-icon-gdpr-document-lock-dark-gray" /> -{' '}
      </>
    );
  };

  const getIsAnonym = (): boolean => {
    return props.isAnonym && (props.type === START_TYPE || props.type === END_TYPE);
  };

  const getElement = (): JSX.Element => {
    return props.type !== MIDNIGHT_ID ? (
      <>
        <i
          className={`cmd-icons cmd-icon-${getIcon(props.type)} mr-2 ${getTextColor(props.type)}`}
        />{' '}
        <span className="mr-1">
          {props.activatedAt ? `${dayjs(props.activatedAt).format('HH:mm:ss')} - ` : getGdprIcon()}
          {getIsAnonym()
            ? f({ id: 'tables.tripsOverview.column.datetime.anonymized' })
            : props.title}
        </span>
      </>
    ) : (
      <div className="text-truncate mr-1 text-gray-light fs-1 font-weight-bold">
        {props.activatedAt
          ? `${dayjs(props.activatedAt).format('DD.MM.YYYY')} -`
          : f({ id: 'tables.tripsOverview.column.datetime.anonymized' })}
        {props.activatedAt &&
          f({
            id: `date.${getDay(String(props.activatedAt))}`,
          })}
      </div>
    );
  };

  return isLong && props.type !== MIDNIGHT_ID && !getIsAnonym() ? (
    <div className="d-flex">
      <TooltipComponent
        id={`event-title-${props.index}`}
        overlay={
          <div style={{ color: '#fff' }}>
            {props.title} {getDuration()}
          </div>
        }
        width="300px"
        firstItems={!props.isLast || props.index === 0 || props.index === 1}
      >
        <div
          style={{
            whiteSpace: 'nowrap',
            width: '400px',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
          }}
        >
          {getElement()}
        </div>
      </TooltipComponent>
      {getDuration()}
    </div>
  ) : (
    <div id={`event-title-${props.rideId}-${props.index}`}>
      {getElement()} {getDuration()}
    </div>
  );
}

export default EventTitle;
